
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/life-insurance",
      function () {
        return require("private-next-pages/products/life-insurance/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/life-insurance"])
      });
    }
  